import styled from 'styled-components';

import { BODY_2_REG_2 } from 'src/client/constants/text';

export const Container = styled.div`
  ${BODY_2_REG_2};
`;
